exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sbd-upload-img[data-v-674a6536]{width:150px;height:150px;border:1px solid #b8b9bd;border-radius:5px;position:relative;z-index:9}.sbd-upload-img.isAuto[data-v-674a6536]{height:auto}.sbd-upload-img .def-icon[data-v-674a6536]{width:98%;margin-left:1%;top:8%;z-index:6;position:absolute}.sbd-upload-img .def-icon i[data-v-674a6536]{font-size:12px;color:#999;float:left}.upload-file[data-v-674a6536]{position:absolute;width:100%;height:100%;opacity:0;z-index:8;left:0;top:0}.upload-avater-s[data-v-674a6536]{width:100%;z-index:7;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-674a6536","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/model/uploadImg/uploadImg.vue
// module id = 9
// module chunks = 0